import { __ } from '../utils';



export const SelectorButton = ({ data, active = false, onClick = null }) => {
	const classNames = ['option--btn'];
	if( active ) {
		classNames.push('active');
	}
	
	return (
		<button className={ classNames.join(' ') } onClick={ () => onClick && onClick() }>
			<div className="option-btn--icon">
				<img src={ data.icon } alt={ data.title } />
			</div>
			
			<div className="option-btn--contents">
				<h6 className="option-btn--title">{ data.title }</h6>
				{ data.price && (
					<div className="option-btn--info">
						{ __('À partir de ') } 
						<strong className="price">{ accounting.formatMoney(data.price) }</strong><br />
						<small>{ __('Hors-livraison') }</small>
					</div>
				)}
				{ data.action && (
					<div className="option-btn--info">
						{ data.action }
					</div>
				)}
			</div>
		</button>
	);
};





export const SelectorOptionsList = ({ value = null, options = [], onChange = null, }) => {
	if( options.length === 0 ) {
		return;
	}
	
	const [ _value, _setValue ] = React.useState(value);
	
	const _change = value => {
		_setValue(value);
		onChange && onChange(value);
	};
	
	return (
		<ul className="option--choices">
			{ options.map((o, i) => { 
				return (
					<li className="option--choice" key={ `option-${i}` }>
						<SelectorButton data={ o } onClick={ () => _change(o.id) } active={ value === o.id } />
					</li>
				);
			}) }
			
		</ul>
	);
}


export const Selector = ({ id, title, children }) => {
	return (
		<div className="box-configuration--option" id={ id }>
			<h5 className="option--title">{ title }</h5>
			
			<div className="option--main">
				{ children }
			</div>
		</div>
	);
}